import reactStringReplace from 'react-string-replace'

export const transactionRequestDirection = {
  In: () => 'TRANSACTION_REQUEST_DIRECTION_IN',
  Out: () => 'TRANSACTION_REQUEST_DIRECTION_OUT',
  Invalid: () => 'TRANSACTION_REQUEST_DIRECTION_INVALID',
}

export const transactionRequestStatus = {
  new: (): string => 'TRANSACTION_REQUEST_STATUS_NEW',
  pendingManager: () => 'TRANSACTION_REQUEST_STATUS_PENDING_MANAGER',
  ps: () => 'TRANSACTION_REQUEST_STATUS_PENDING_PS',
  pendingDestination: () => 'TRANSACTION_REQUEST_STATUS_PENDING_DESTINATION',
  accepted: () => 'TRANSACTION_REQUEST_STATUS_ACCEPTED',
  rejected: () => 'TRANSACTION_REQUEST_STATUS_REJECTED',
  pendingRollback: () => 'TRANSACTION_REQUEST_STATUS_PENDING_ROLLBACK',
  rollback: () => 'TRANSACTION_REQUEST_STATUS_ROLLBACK',
  invalid: () => 'TRANSACTION_REQUEST_STATUS_INVALID',
  questions: () => 'TRANSACTION_REQUEST_STATUS_HAS_QUESTIONS',
  noQuestions: () => 'TRANSACTION_REQUEST_STATUS_HAS_NO_QUESTIONS',
  missingInformation: () => 'TRANSACTION_REQUEST_STATUS_MISSING_INFORMATION',
  cancelMissingInformation: () =>
    'TRANSACTION_REQUEST_STATUS_CANCEL_REQUEST_CLIENT_INFORMATION',
  fundsReserved: () => 'TRANSACTION_REQUEST_STATUS_FUNDS_RESERVED',
  fundsUnReserved: () => 'TRANSACTION_REQUEST_STATUS_FUNDS_UNRESERVED',
  unconfirmed: () => 'TRANSACTION_REQUEST_STATUS_UNCONFIRMED',
  vendorError: () => 'TRANSACTION_REQUEST_STATUS_VENDOR_ERROR',
  internalError: () => 'TRANSACTION_REQUEST_STATUS_INTERNAL_ERROR',
  pendingAutoCheck: () => 'TRANSACTION_REQUEST_STATUS_PENDING_AUTO_CHECK',
  completed: () => 'STATUS_COMPLETED',
  dealersCheck: () => 'TRANSACTION_REQUEST_STATUS_DEALERS_CHECK',
  cancelDealersCheck: () =>
    'INTERNAL_TRANSACTION_REQUEST_STATUS_CANCEL_DEALERS_CHECK',
}

export const transactionRequestDestinationType = {
  wallet: () => 'TRANSACTION_REQUEST_DESTINATION_TYPE_WALLET',
  account: () => 'TRANSACTION_REQUEST_DESTINATION_TYPE_ACCOUNT',
  invalid: () => 'TRANSACTION_REQUEST_DESTINATION_TYPE_INVALID',
}

export const internalTransferStatus = {
  invalid: () => 'invalid',
  waitingForApprove: () => 'waiting_for_approve',
  rejected: () => 'rejected',
  awaitingDebiting: () => 'awaiting_debiting',
  inDebiting: () => 'in_debiting',
  awaitingCrediting: () => 'awaiting_crediting',
  inCrediting: () => 'in_crediting',
  pendingRollback: () => 'pending_rollback',
  rollingBack: () => 'rolling_back',
  completed: () => 'completed',
  failed: () => 'failed',
  internalError: () => 'internal_error',
}

export const humanTransactionRequestStatus = function (status: string) {
  switch (status) {
    case transactionRequestStatus.new():
      return 'New'
    case transactionRequestStatus.accepted():
    case transactionRequestStatus.completed():
      return 'Accepted'
    case transactionRequestStatus.rejected():
      return 'Rejected'
    case transactionRequestStatus.fundsReserved():
      return 'Funds reserved'
    case transactionRequestStatus.fundsUnReserved():
      return 'Funds unreserved'
    case transactionRequestStatus.unconfirmed():
      return 'Unconfirmed'
    case transactionRequestStatus.questions():
      return 'Has questions'
    case transactionRequestStatus.noQuestions():
      return 'No questions'
    case transactionRequestStatus.missingInformation():
      return 'Missing information'
    case transactionRequestStatus.cancelMissingInformation():
      return 'Canceling missing information'
    case transactionRequestStatus.vendorError():
      return 'Vendor error'
    case transactionRequestStatus.pendingManager():
      return 'Pending manager'
    case transactionRequestStatus.ps():
      return 'Pending PS'
    case transactionRequestStatus.pendingDestination():
      return 'Pending destination'
    case transactionRequestStatus.pendingRollback():
      return 'Pending rollback'
    case transactionRequestStatus.rollback():
      return 'Rollback'
    case transactionRequestStatus.internalError():
      return 'Internal Error'
    case transactionRequestStatus.pendingAutoCheck():
      return 'Pending auto check'
    case transactionRequestStatus.invalid():
      return 'Invalid'
    case transactionRequestStatus.dealersCheck():
      return 'Dealers check'
    default:
      return status
  }
}

export const shortTransactionRequestStatus = function (status: string) {
  switch (status) {
    case transactionRequestStatus.new():
      return 'N'
    case transactionRequestStatus.accepted():
    case transactionRequestStatus.completed():
      return 'A'
    case transactionRequestStatus.rejected():
      return 'R'
    case transactionRequestStatus.fundsReserved():
      return 'FR'
    case transactionRequestStatus.fundsUnReserved():
      return 'FU'
    case transactionRequestStatus.unconfirmed():
      return 'UC'
    case transactionRequestStatus.questions():
      return 'HQ'
    case transactionRequestStatus.noQuestions():
      return 'NQ'
    case transactionRequestStatus.missingInformation():
      return 'MI'
    case transactionRequestStatus.cancelMissingInformation():
      return 'CM'
    case transactionRequestStatus.vendorError():
      return 'VE'
    case transactionRequestStatus.pendingManager():
      return 'PM'
    case transactionRequestStatus.ps():
      return 'PS'
    case transactionRequestStatus.pendingDestination():
      return 'PD'
    case transactionRequestStatus.pendingRollback():
      return 'PR'
    case transactionRequestStatus.rollback():
      return 'RB'
    case transactionRequestStatus.internalError():
      return 'IE'
    case transactionRequestStatus.pendingAutoCheck():
      return 'PA'
    case transactionRequestStatus.invalid():
      return 'INV'
    default:
      return status
  }
}

export const humanTransactionRequestStatusButton = function (
  status: string,
  processingProvider?: string,
) {
  switch (status) {
    case transactionRequestStatus.new():
      return 'New'
    case transactionRequestStatus.accepted():
      return 'Accept internal'
    case transactionRequestStatus.rejected():
      return 'Reject'
    case transactionRequestStatus.fundsReserved():
      return 'Reserve funds'
    case transactionRequestStatus.fundsUnReserved():
      return 'Return funds'
    case transactionRequestStatus.missingInformation():
      return 'Missing information'
    case transactionRequestStatus.cancelMissingInformation():
      return 'Canceling missing information'
    case transactionRequestStatus.pendingManager():
      return 'Pending manager'
    case transactionRequestStatus.ps():
      return processingProvider === 'praxis_n' ||
        processingProvider === 'praxis'
        ? 'Accept with praxis'
        : 'Accept with PS'
    case transactionRequestStatus.questions():
      return 'Has questions'
    case transactionRequestStatus.noQuestions():
      return 'No questions'
    case transactionRequestStatus.rollback():
      return 'Rollback'
    case transactionRequestStatus.vendorError():
      return 'Vendor error'
    case transactionRequestStatus.internalError():
      return 'Internal Error'
    case transactionRequestStatus.pendingAutoCheck():
      return 'Pending auto check'
    case transactionRequestStatus.pendingDestination():
    case transactionRequestStatus.pendingRollback():
      return 'Pending'
    default:
      return status
  }
}

export const buttonColorTransactionRequestStatus = function (status: string) {
  switch (status) {
    case transactionRequestStatus.new():
      return {
        text: '#000000',
        background: '#1f3d0f',
      }
    case transactionRequestStatus.accepted():
      return {
        text: '#000000',
        background: '#73d13d',
      }
    case transactionRequestStatus.rejected():
      return {
        text: '#ffffff',
        background: '#e55353',
      }
    case transactionRequestStatus.missingInformation():
    case transactionRequestStatus.cancelMissingInformation():
      return {
        text: '#ffffff',
        background: '#5c0011',
      }
    case transactionRequestStatus.fundsReserved():
    case transactionRequestStatus.fundsUnReserved():
      return {
        text: '#000000',
        background: '#36cfc9',
      }
    case transactionRequestStatus.pendingManager():
    case transactionRequestStatus.pendingDestination():
    case transactionRequestStatus.pendingRollback():
    case transactionRequestStatus.pendingAutoCheck():
      return {
        text: '#000000',
        background: '#69b1ff',
      }
    case transactionRequestStatus.ps():
      return {
        text: '#000000',
        background: '#ffc53d',
      }
    case transactionRequestStatus.questions():
    case transactionRequestStatus.noQuestions():
      return {
        text: '#000000',
        background: '#bae637',
      }
    case transactionRequestStatus.dealersCheck():
      return {
        text: '#ffffff',
        background: '#d4380d',
      }
    default:
      return {
        text: '#ffffff',
        background: '#d4b106',
      }
  }
}

export const withdrawalRejectionReason = {
  notMoney: () => ({
    label: 'Not enough available funds.',
    key: 'info.payment-reject-reason-not-money',
    type: 1,
  }),
  wrongEwalletNumber: () => ({
    label: '{Ewallet_number} is a wrong E-wallet number.',
    key: 'info.withdrawal-reject-reason-wrong-ewallet-number',
    type: 2,
  }),
  wrongBankNumber: () => ({
    label: '{Bank_account_number} is a wrong bank account number.',
    key: 'info.withdrawal-reject-reason-wrong-bank-number',
    type: 0,
  }),
  ewalletWrongName: () => ({
    label:
      'E-wallet {Ewallet_number} is not registered under your name {fname}.',
    key: 'info.withdrawal-reject-reason-ewallet-wrong-name',
    type: 3,
  }),
  bankStrangeName: () => ({
    label:
      'Bank account number {Bank_account_number} is not registered under your name. Please use your own bank account or contact Headway Customer Care.',
    key: 'info.withdrawal-reject-reason-bank-strange-name',
    type: 4,
  }),
  toPs: () => ({
    label:
      'Withdrawals are processed back to the same account from which you made the deposit(s) from. Please make a withdrawal request to {PS}.',
    key: 'info.withdrawal-reject-reason-to-ps',
    type: 5,
  }),
  support: () => ({
    label: 'Please contact Headway Customer Care: care@hw.site',
    key: 'info.payment-reject-reason-support',
    type: 6,
  }),
  makeAmountToEwallet: () => ({
    label:
      'You can withdraw {amount} to {PS} and the remaining amount to {Ewallet_number} E-wallet.',
    key: 'info.withdrawal-reject-reason-make-amount-to-ewallet',
    type: 7,
  }),
  bankWrongName: () => ({
    label:
      '{Bank_account_name} is a wrong bank account nickname. Please enter your full bank account nickname {fname}',
    key: 'info.withdrawal-reject-reason-bank-wrong-name',
    type: 8,
  }),
  onlyOwnAccount: () => ({
    label: 'You can withdraw your funds to your own bank account only.',
    key: 'info.withdrawal-reject-reason-only-own-account',
    type: 9,
  }),
  confirmEwallet: () => ({
    label:
      'Please confirm that your e-wallet {Ewallet_number} is under your name or contact  Headway Customer Care.',
    key: 'info.withdrawal-reject-reason-confirm-ewallet',
    type: 10,
  }),
  maintenance: () => ({
    label:
      'Due to technical maintenance we are unable to process this withdrawal request. We apologize for the inconvenience.',
    key: 'info.payment-reject-reason-maintenance',
    type: 11,
  }),
  partnership: () => ({
    label: 'Please contact the Headway Partnership Department: partner@hw.site',
    key: 'info.payment-reject-reason-partnership',
    type: 12,
  }),
  idToSupport: () => ({
    label:
      'Please email us at care@hw.site and attach a photo of you holding your ID next to your face for further identity confirmation.',
    key: 'info.withdrawal-reject-reason-id-to-support',
    type: 13,
  }),
  cardCanAccept: () => ({
    label:
      'Please confirm that your virtual card {card_number} can accept funds or contact  Headway Customer Care.',
    key: 'info.withdrawal-reject-reason-card-can-accept',
    type: 14,
  }),
  wrongCryptoAddress: () => ({
    label: '{cryptoaddress_number} is a wrong crypto address',
    key: 'info.payment-reject-reason-wrong-cryptoaddress',
    type: 15,
  }),
  cardNotVerified: () => ({
    label:
      '{card_number} not verified. Please verify the card and create a new request.',
    key: 'info.payment-reject-reason-card-not-verified',
    type: 0,
  }),
  custom: () => ({
    label: '{custom}',
    key: 'info.custom-payment-reject-reason',
    type: 17,
  }),
  withdrawalWithoutTrade: () => ({
    label:
      'You are making a withdrawal without trading. We advise for you to trade before making your withdrawal request or make another withdrawal request with commission charge {commission_one}% for your last deposit and {commission_two}% for the withdrawal.',
    key: 'info.withdrawal-without-trade',
    type: 16,
  }),
  secondWD: () => ({
    label: 'Second WD without trading.',
    key: 'info.payment-reject-reason-order-not-paid',
    type: 18,
  }),
  contactSupport: () => ({
    label: 'Silence contact support(without Money Honey)',
    key: 'info.payment-reject-reason-support',
    type: 19,
  }),
  withdrawalReasonAnotherPS: () => ({
    label: 'Please make a withdrawal request to {ps_name}',
    key: 'info.withdrawal-reject-reason-another-ps',
    type: 20,
  }),
  withdrawalReasonPSErrorTryAgain: () => ({
    label:
      "Please create a new withdrawal, unfortunately by technical reasons this withdrawal hasn't been processed on a payment system side, thank you",
    key: 'info.withdrawal-reject-reason-ps-error-try-again',
    type: 21,
  }),
}

export const missingInformationReason = {
  withdrawalWithoutTrading: () => ({
    label:
      'As per our policy, we charge a commission for deposits and withdrawals from accounts with no trading activity. Your withdrawal will incur a commission of {commission}. To confirm or cancel your withdrawal request, please contact our Customer Care via care@hw.site.',
    key: 'info.withdrawal-without-trading',
    type: 1,
  }),
  confirmYourCryptoWallet: () => ({
    label:
      'Please confirm that {wallet} is correct {gateway_name} address and belongs to you. Send screenshot shown your wallet address with name or email to e-mail care@hw.site.',
    key: 'info.confirm-your-crypto-wallet',
    type: 2,
  }),
  contactSupport: () => ({
    label: 'Contact support',
    key: 'info.payment-reject-reason-support',
    type: 4,
  }),
  custom: () => ({
    label: '{custom}',
    key: 'info.reason',
    type: 3,
  }),
}

function placeholderReplacer(text: string, params: {}) {
  return reactStringReplace(text, /\{(.*?)}/g, (match: string, i: any) => {
    // @ts-ignore
    if (params['{' + match + '}']) {
      // @ts-ignore
      return params['{' + match + '}']
    }
  })
}

export const humanWithdrawalRejectionReason = function (
  rejectionReason: string,
) {
  let managerReason: { key: string; params: [] }
  try {
    managerReason = JSON.parse(rejectionReason)
  } catch (e) {
    return rejectionReason
  }
  let reason: string
  switch (managerReason?.key) {
    case withdrawalRejectionReason.notMoney().key:
      reason = withdrawalRejectionReason.notMoney().label
      break
    case withdrawalRejectionReason.wrongEwalletNumber().key:
      reason = withdrawalRejectionReason.wrongEwalletNumber().label
      break
    case withdrawalRejectionReason.wrongBankNumber().key:
      reason = withdrawalRejectionReason.wrongBankNumber().label
      break
    case withdrawalRejectionReason.ewalletWrongName().key:
      reason = withdrawalRejectionReason.ewalletWrongName().label
      break
    case withdrawalRejectionReason.bankStrangeName().key:
      reason = withdrawalRejectionReason.bankStrangeName().label
      break
    case withdrawalRejectionReason.toPs().key:
      reason = withdrawalRejectionReason.toPs().label
      break
    case withdrawalRejectionReason.support().key:
      reason = withdrawalRejectionReason.support().label
      break
    case withdrawalRejectionReason.makeAmountToEwallet().key:
      reason = withdrawalRejectionReason.makeAmountToEwallet().label
      break
    case withdrawalRejectionReason.bankWrongName().key:
      reason = withdrawalRejectionReason.bankWrongName().label
      break
    case withdrawalRejectionReason.onlyOwnAccount().key:
      reason = withdrawalRejectionReason.onlyOwnAccount().label
      break
    case withdrawalRejectionReason.confirmEwallet().key:
      reason = withdrawalRejectionReason.confirmEwallet().label
      break
    case withdrawalRejectionReason.maintenance().key:
      reason = withdrawalRejectionReason.maintenance().label
      break
    case withdrawalRejectionReason.partnership().key:
      reason = withdrawalRejectionReason.partnership().label
      break
    case withdrawalRejectionReason.idToSupport().key:
      reason = withdrawalRejectionReason.idToSupport().label
      break
    case withdrawalRejectionReason.cardCanAccept().key:
      reason = withdrawalRejectionReason.cardCanAccept().label
      break
    case withdrawalRejectionReason.wrongCryptoAddress().key:
      reason = withdrawalRejectionReason.wrongCryptoAddress().label
      break
    case withdrawalRejectionReason.cardNotVerified().key:
      reason = withdrawalRejectionReason.cardNotVerified().label
      break
    case withdrawalRejectionReason.withdrawalWithoutTrade().key:
      reason = withdrawalRejectionReason.withdrawalWithoutTrade().label
      break
    case withdrawalRejectionReason.withdrawalReasonAnotherPS().key:
      reason = withdrawalRejectionReason.withdrawalReasonAnotherPS().label
      break
    case withdrawalRejectionReason.withdrawalReasonPSErrorTryAgain().key:
      reason = withdrawalRejectionReason.withdrawalReasonPSErrorTryAgain().label
      break
    default:
      reason = ''
  }

  if (reason.length > 0) {
    return placeholderReplacer(reason, managerReason.params)
  }

  return rejectionReason
}
export const depositRejectionReason = {
  notFound: () => ({
    label:
      'Payment is not found. Please attach a payment confirmation and make sure all the information (date, time, amount, beneficiary) is clear and visible.',
    key: 'info.deposit-reject-reason-payment-not-found',
  }),
  alreadyAccepted: () => ({
    label: 'This deposit has already been accepted.',
    key: 'info.deposit-reject-reason-already-accepted',
  }),
  wrongAmount: () => ({
    label: 'Wrong deposit amount. Please double check the deposit amount.',
    key: 'info.deposit-reject-reason-wrong-amount',
  }),
  wrongBankAccountNumber: () => ({
    label:
      'Wrong bank account number. Make sure you enter your bank account number.',
    key: 'info.deposit-reject-reason-wrong-bank-account-number',
  }),
  anotherName: () => ({
    label:
      "The name of the client who created a deposit request differs from the name of the bank account's holder. Please contact the Headway Customer Support Service for further steps.",
    key: 'info.deposit-reject-reason-another-name',
  }),
  makeRequest: () => ({
    label: 'Please make a request to a beneficiary bank.',
    key: 'info.deposit-reject-reason-make-request',
  }),
  reasonSupport: () => ({
    label: 'Please contact Headway Customer Care at care@hw.site',
    key: 'info.payment-reject-reason-support',
  }),
  partnership: () => ({
    label: 'Please contact the Headway Partnership Department: partner@hw.site',
    key: 'info.payment-reject-reason-partnership',
  }),
  autoByBs: () => ({
    label: 'The payment was rejected by the payment system.',
    key: 'info.payment-reject-reason-auto-by-ps',
  }),
  novaReject: () => ({
    label:
      'The transaction was cancelled, because the order was not paid in full.',
    key: 'info.payment-reject-reason-order-not-paid',
  }),
  thirdParty: () => ({
    label: 'Third-Party Deposit Restriction.',
    key: 'info.payment-reject-reason-order-not-paid',
  }),
}

export const humanDepositRejectionReason = function (rejectionReason: string) {
  let managerReason: { key: string; params: [] }
  try {
    managerReason = JSON.parse(rejectionReason)
  } catch (e) {
    return rejectionReason
  }
  let reason: string
  switch (managerReason?.key) {
    case depositRejectionReason.notFound().key:
      reason = depositRejectionReason.notFound().label
      break
    case depositRejectionReason.alreadyAccepted().key:
      reason = depositRejectionReason.alreadyAccepted().label
      break
    case depositRejectionReason.wrongAmount().key:
      reason = depositRejectionReason.wrongAmount().label
      break
    case depositRejectionReason.wrongBankAccountNumber().key:
      reason = depositRejectionReason.wrongBankAccountNumber().label
      break
    case depositRejectionReason.anotherName().key:
      reason = depositRejectionReason.anotherName().label
      break
    case depositRejectionReason.makeRequest().key:
      reason = depositRejectionReason.makeRequest().label
      break
    case depositRejectionReason.reasonSupport().key:
      reason = depositRejectionReason.reasonSupport().label
      break
    case depositRejectionReason.partnership().key:
      reason = depositRejectionReason.partnership().label
      break
    case depositRejectionReason.autoByBs().key:
      reason = depositRejectionReason.autoByBs().label
      break
    default:
      reason = ''
  }

  if (reason.length > 0) {
    return reason
  }

  return rejectionReason
}

export const statusWithdrawalFlow = function (
  status: string,
  mtTransactionId?: number,
): [] {
  let flow = {}

  // @ts-ignore
  flow[transactionRequestStatus.pendingManager()] = [
    transactionRequestStatus.questions(),
    transactionRequestStatus.rejected(),
    transactionRequestStatus.fundsReserved(),
    transactionRequestStatus.dealersCheck(),
  ]
  // @ts-ignore
  flow[transactionRequestStatus.ps()] = [transactionRequestStatus.accepted()]
  // @ts-ignore
  flow[transactionRequestStatus.vendorError()] = [
    transactionRequestStatus.accepted(),
    transactionRequestStatus.rollback(),
  ]
  // @ts-ignore
  flow[transactionRequestStatus.unconfirmed()] = [
    transactionRequestStatus.rejected(),
    transactionRequestStatus.fundsReserved(),
  ]
  // @ts-ignore
  flow[transactionRequestStatus.fundsReserved()] = [
    transactionRequestStatus.fundsUnReserved(),
    transactionRequestStatus.accepted(),
    transactionRequestStatus.ps(),
    transactionRequestStatus.missingInformation(),
  ]
  // @ts-ignore
  flow[transactionRequestStatus.missingInformation()] = [
    transactionRequestStatus.cancelMissingInformation(),
  ]
  // @ts-ignore
  flow[transactionRequestStatus.questions()] = [
    transactionRequestStatus.noQuestions(),
  ]
  // @ts-ignore
  flow[transactionRequestStatus.rejected()] = [
    transactionRequestStatus.rollback(),
  ]
  // @ts-ignore
  flow[transactionRequestStatus.accepted()] = [
    transactionRequestStatus.rollback(),
  ]
  if (mtTransactionId) {
    // @ts-ignore
    flow[transactionRequestStatus.vendorError()] = [
      transactionRequestStatus.rollback(),
      transactionRequestStatus.accepted(),
    ]
  }
  // @ts-ignore
  flow[transactionRequestStatus.internalError()] = [
    transactionRequestStatus.rejected(),
  ]
  // @ts-ignore
  flow[transactionRequestStatus.dealersCheck()] = [
    transactionRequestStatus.pendingManager(),
  ]
  // @ts-ignore
  return flow[status]
}

export const statusDepositFlow = function (status: string): [] {
  let flow = {}

  // @ts-ignore
  flow[transactionRequestStatus.new()] = [
    transactionRequestStatus.accepted(),
    transactionRequestStatus.rejected(),
  ]
  // @ts-ignore
  flow[transactionRequestStatus.pendingManager()] = [
    transactionRequestStatus.accepted(),
    transactionRequestStatus.rejected(),
  ]
  // @ts-ignore
  flow[transactionRequestStatus.ps()] = [
    transactionRequestStatus.accepted(),
    transactionRequestStatus.rejected(),
  ]
  // @ts-ignore
  flow[transactionRequestStatus.rejected()] = [
    transactionRequestStatus.rollback(),
  ]
  // @ts-ignore
  flow[transactionRequestStatus.accepted()] = [
    transactionRequestStatus.rollback(),
  ]
  // @ts-ignore
  flow[transactionRequestStatus.vendorError()] = [
    transactionRequestStatus.rollback(),
  ]
  // @ts-ignore
  flow[transactionRequestStatus.internalError()] = [
    transactionRequestStatus.rollback(),
  ]
  // @ts-ignore
  return flow[status]
}

export const colorTransactionRequestStatus = function (status: string) {
  switch (status) {
    case transactionRequestStatus.new():
      return '#73d13d'
    case transactionRequestStatus.accepted():
    case transactionRequestStatus.completed():
      return '#2eb85c'
    case transactionRequestStatus.rejected():
      return '#e55353'
    case transactionRequestStatus.ps():
      return '#00b3b3'
    case transactionRequestStatus.pendingManager():
    case transactionRequestStatus.pendingDestination():
    case transactionRequestStatus.pendingRollback():
    case transactionRequestStatus.pendingAutoCheck():
      return '#321fdb'
    default:
      return '#d4b106'
  }
}

export const colorInternalTransferStatus = function (status: string) {
  switch (status) {
    case internalTransferStatus.invalid():
      return '#880a38'
    case internalTransferStatus.waitingForApprove():
      return '#ebedef'
    case internalTransferStatus.rejected():
      return '#f04134'
    case internalTransferStatus.awaitingDebiting():
      return '#108ee9'
    case internalTransferStatus.inDebiting():
      return '#073069'
    case internalTransferStatus.awaitingCrediting():
      return '#7265e6'
    case internalTransferStatus.inCrediting():
      return '#321580'
    case internalTransferStatus.pendingRollback():
      return '#fde3cf'
    case internalTransferStatus.rollingBack():
      return '#f78e3d'
    case internalTransferStatus.completed():
      return '#3dbd7d'
    case internalTransferStatus.failed():
      return '#fabeb9'
    default:
      return '#d4b106'
  }
}

export const buttonColorInternalTransferStatus = function (status: string) {
  switch (status) {
    case internalTransferStatus.invalid():
      return {
        text: '#000000',
        background: '#880a38',
      }
    case internalTransferStatus.waitingForApprove():
      return {
        text: '#000000',
        background: '#3dbd7d',
      }
    case internalTransferStatus.rejected():
      return {
        text: '#000000',
        background: '#f04134',
      }
    case internalTransferStatus.awaitingDebiting():
      return {
        text: '#000000',
        background: '#108ee9',
      }
    case internalTransferStatus.inDebiting():
      return {
        text: '#000000',
        background: '#073069',
      }
    case internalTransferStatus.awaitingCrediting():
      return {
        text: '#000000',
        background: '#7265e6',
      }
    case internalTransferStatus.inCrediting():
      return {
        text: '#000000',
        background: '#321580',
      }
    case internalTransferStatus.pendingRollback():
      return {
        text: '#000000',
        background: '#fde3cf',
      }
    case internalTransferStatus.rollingBack():
      return {
        text: '#000000',
        background: '#f78e3d',
      }
    case internalTransferStatus.completed():
      return {
        text: '#000000',
        background: '#3dbd7d',
      }
    case internalTransferStatus.failed():
      return {
        text: '#000000',
        background: '#fabeb9',
      }
    default:
      return {
        text: '#000000',
        background: '#d4b106',
      }
  }
}

export const humanInternalTransferStatus = function (status: string) {
  switch (status) {
    case internalTransferStatus.invalid():
      return 'Invalid'
    case internalTransferStatus.waitingForApprove():
      return 'Waiting for approve'
    case internalTransferStatus.rejected():
      return 'Rejected'
    case internalTransferStatus.awaitingDebiting():
      return 'Awaiting debiting'
    case internalTransferStatus.inDebiting():
      return 'In debiting'
    case internalTransferStatus.awaitingCrediting():
      return 'Awaiting crediting'
    case internalTransferStatus.inCrediting():
      return 'In crediting'
    case internalTransferStatus.pendingRollback():
      return 'Pending rollback'
    case internalTransferStatus.rollingBack():
      return 'Rolling back'
    case internalTransferStatus.completed():
      return 'Completed'
    case internalTransferStatus.failed():
      return 'Failed'
    default:
      return status
  }
}

export const statusInternalTransferFlow = function (status: string): [] {
  let flow = {}

  // @ts-ignore
  flow[internalTransferStatus.waitingForApprove()] = [
    internalTransferStatus.completed(),
    internalTransferStatus.rejected(),
  ]
  // @ts-ignore
  return flow[status]
}

export const currencyFilterList = [
  {
    text: 'USD',
    value: 'USD',
  },
  {
    text: 'EUR',
    value: 'EUR',
  },
  {
    text: 'IDR',
    value: 'IDR',
  },
  {
    text: 'MYR',
    value: 'MYR',
  },
  {
    text: 'PHP',
    value: 'PHP',
  },
  {
    text: 'THB',
    value: 'THB',
  },
  {
    text: 'JPY',
    value: 'JPY',
  },
  {
    text: 'BRL',
    value: 'BRL',
  },
  {
    text: 'VND',
    value: 'VND',
  },
  {
    text: 'USDT',
    value: 'USDT',
  },
  {
    text: 'BTC',
    value: 'BTC',
  },
  {
    text: 'LTC',
    value: 'LTC',
  },
  {
    text: 'NGN',
    value: 'NGN',
  },
  {
    text: 'ZAR',
    value: 'ZAR',
  },
  {
    text: 'OTHER',
    value: 'OTHER',
  },
]

export const ozowBankMapping: Record<string, string> = {
  '3284a0ad-ba78-4838-8c2b-102981286a2b': 'ABSA',
  'd560b4e6-3ecd-487e-8fe4-497be3b7bd95': 'Access Bank',
  '33a0840b-0cf4-4b8c-86e0-ec6c4be8c60e': 'African Bank',
  '44356c06-1081-4ced-8669-760cf3165712': 'Albaraka Bank ',
  '965aa3ab-fb35-451b-9e05-20e95dd51c55': 'Bank Zero',
  '8d77e501-5990-4cd1-bb08-3d3fe402fb20': 'Bank of Athens',
  '29c5ee92-46ec-4879-8ad9-5cd3f5502727': 'Bidvest Bank',
  '913999fa-3a32-4e3d-82f0-a1df7e9e4f7b': 'Capitec Bank',
  '7fc2d14c-5021-497d-a73e-1788d6ce3ff3': 'Citi Bank',
  'b8f152a2-8bd2-46c4-930f-4cd5b2b37ef9': 'Discovery Bank',
  '4816019c-3314-4c80-8b6b-b2cd16dcc4ec': 'FNB',
  '2c7bbd14-cd96-4b4f-96f9-ad9ba228366d': 'HSBC Bank',
  '4b45be85-b616-4bd1-9027-f8fcf8f9af7b': 'Investec',
  '9e1917ad-29d1-4d11-80b5-0f6c33ae1083': 'Mercantile bank',
  'bf0561fd-4203-4a0c-9174-cb26fcd87a60': 'Nedbank',
  'c36c2423-8a06-4393-bf2d-f5da82d67bc7': 'Olympus Mobile',
  'cc08d678-09cb-49c8-bcd8-2ec9e3bd0a82': 'RMB',
  '54a18018-a9fe-4adb-b752-38004ed735d6': 'Sasfin Bank',
  'ad7d8da4-1723-4066-94bb-6662d845e483': 'Standard bank',
  'c296d0d8-ad0b-43b4-96c2-de30ad039561': 'Standard Chartered Bank',
  '28fcc8fa-985b-480b-82fd-7d09bc19c9d0': 'Tyme Bank',
  '8ff9fbc7-9e14-47bc-8d91-cbc81cf131e9': 'Ubank Limited',
}

export const payretailersBankMapping: Record<string, string> = {
  '0001': 'BANCO DE BOGOTA',
  '0002': 'BANCO POPULAR',
  '0006': 'BANCO CORPBANCA COLOMBIA SA.',
  '0007': 'BANCOLOMBIA',
  '0009': 'CITIBANK',
  '0012': 'BANCO GNB SUDAMERIS',
  '0013': 'BBVA COLOMBIA',
  '0014': 'ITAÚ',
  '0019': 'BANCO COLPATRIA',
  '0023': 'BANCO DE OCCIDENTE',
  '0031': 'BANCOLDEX',
  '0032': 'BANCO BCSC SA (Banco Caja Social)',
  '0040': 'BANCO AGRARIO',
  '0041': 'JPMORGAN CORPORACION FINANCIERA',
  '0042': 'BNP PARIBAS',
  '0051': 'BANCO DAVIVIENDA S.A.',
  '0052': 'BANCO AV VILLAS',
  '0058': 'BANCO PROCREDIT',
  '0059': 'BANCAMIA S.A',
  '0060': 'BANCO PICHINCHA',
  '0061': 'BANCOOMEVA',
  '0062': 'BANCO FALABELLA S.A.',
  '0063': 'BANCO FINANDINA',
  '0064': 'BANCO MULTIBANK S.A.',
  '0065': 'BANCO SANTANDER DE NEGOCIOS COLOMBIA SA',
  '0066': 'BANCO COOPERATIVO COOPCENTRAL',
  '0067': 'BANCO COMPARTIR S.A.',
  '0069': 'SERFINANSA S.S',
  '0070': 'LULO BANK',
  '0071': 'BANCO J.P. MORGAN COLOMBIA S.A.',
  '0083': 'COMPENSAR',
  '0084': 'GESTION CONTACTO',
  '0086': 'ASOPAGOS',
  '0087': 'FEDECAJAS',
  '0088': 'SIMPLE S.A',
  '0089': 'ENLACE OPERATIVO',
  '0121': 'FINANCIERA JURISCOP S.A.',
  '0283': 'COOPERTIVA FINANCIERA ANTIOQUIA',
  '0289': 'COTRAFA COOPERATIVA FINANCIERA',
  '0291': 'COFINEP COOPERATIVA FINANCIERA',
  '0292': 'CONFIAR',
  '0303': 'BANCO UNION ANTES GIROS Y FINANZAS',
  '0370': 'COLTEFINANCIERA S.A',
  '0507': 'NEQUI',
  '0550': 'DECEVAL',
  '0551': 'DAVIPLATA',
  '0558': 'BAN100',
  '0560': 'PIBANK',
  '0683': 'DGCPTN',
  '0685': 'DGCPTN * Sistema General de Regalias',
  '0801': 'MOVII',
  '0802': 'DING TECNIPAGOS SA',
  '0803': 'POWWI',
  '0804': 'UALÁ BANCAR TECNOLOGIA',
  '0805': 'BTG PACTUAL',
  '0808': 'BOLD CF',
  '0811': 'RAPPIPAY',
  '0812': 'COINK S.A',
  '0813': 'SANTANDER CONSUMER',
  '0814': 'GLOBAL66',
}
